import * as React from 'react';
import styled from 'styled-components';
import TopNavigation from './navigation/top/TopNavigation';
import LeftNavigation from './navigation/left/LeftNavigation';
import CompanySearch from 'components/companysearch/CompanySearch';
import MobileNavigation from './navigation/mobile/MobileNavigation';
import CommonFooter from 'components/common/Footer';
import ContentRouterWidget from '@almamedia/ict-content-router-react';

const Main = styled.div`
    display: flex;
`;

const Section = styled.div`
    flex: 1 1 auto;
    min-width: 600px;
`;

export default function BasicLayout(props: any) {
    return (
        <>
            <TopNavigation />
            <Main>
                <LeftNavigation />
                <Section>
                    <CompanySearch />
                    {props.children}
                </Section>
                <MobileNavigation />
            </Main>
            <CommonFooter />
            <ContentRouterWidget slot="ALMA_FOOTER" />
        </>
    );
}
